import PlayButton from '../common/PlayButton';

const VideoSection = () => {
  const handlePlayClick = (e) => {
    e.preventDefault();
    console.log('Video play button clicked');
  };

  return (
    <section className="relative w-full h-[75vh] min-h-[400px] overflow-hidden">
      {/* Background Image */}
      <img 
        src="/assets/imgs/Home/Video/Rectangle 1 copy 4.png" 
        alt="et Kryll" 
        className="w-full h-full object-cover object-top"
      />

      {/* Play Button - Centered (same styling as Hero) */}
      <PlayButton onClick={handlePlayClick} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10" />
    </section>
  );
};

export default VideoSection;
